import Request from './index'

class Api {

  //全站综合搜索
  static publicSearch(data){
    return Request.get('/base/search', {
      params: {
        page: data.page,
        page_size: data.page_size,
        keyword: data.keyword
      }
    })
  }

}

export default Api